import sha256 from 'crypto-js/sha256';
import { isEmpty } from 'lodash';

export const dataList = [];

export const generateList = data => {
    data?.forEach(item => {
        const { key, title, children } = item;
        dataList.push({ key, title });

        if (children) {
            generateList(children);
        }
    });
};

export const getParentKey = (key, tree) => {
    let parentKey;

    tree?.forEach(treeItem => {
        if (treeItem.children) {
            if (treeItem.children.some(item => item.key === key)) {
                parentKey = treeItem.key;
            } else if (getParentKey(key, treeItem.children)) {
                parentKey = getParentKey(key, treeItem.children);
            }
        }
    });

    return parentKey;
};

export const updateTreeData = (list, key, children) => {
    return list?.map(node => {
        if (node.key === key) {
            return { ...node, children };
        }
        if (node.children) {
            return { ...node, children: updateTreeData(node.children, key, children) };
        }

        return node;
    });
};

/* work with store */

export const getItemByKeyRecursive = (inputItems, itemKey, parentItemKey = null) => {
    if (!inputItems) return null;
    const outputItems = [...inputItems];
    const index = outputItems.findIndex(item => item?.key === itemKey);
    if (index !== -1) {
        if (parentItemKey) {
            outputItems[index].parentKey = parentItemKey;
        }
        return outputItems[index];
    }
    return outputItems.reduce(
        (result, nextItem) =>
            nextItem?.children ? getItemByKeyRecursive(nextItem.children, itemKey, nextItem.key) || result : result,
        null,
    );
};

export const removeItemByKeyRecursive = (inputItems, itemKey) => {
    if (!inputItems) return [];
    const outputItems = inputItems.map(item => {
        const newItem = { ...item };
        if (newItem?.key === itemKey) {
            return null;
        }
        if (newItem?.children) {
            newItem.children = removeItemByKeyRecursive(newItem.children, itemKey);
        }
        return newItem;
    });
    return outputItems;
};

export const setItemByKeyRecursive = (inputItems, itemKey, newItem) => {
    if (!inputItems) return [];
    const outputItems = inputItems.map(item => {
        const oldItem = { ...item };
        if (oldItem?.key === itemKey) {
            return newItem;
        }
        if (oldItem?.children) {
            oldItem.children = setItemByKeyRecursive(oldItem.children, itemKey, newItem);
        }
        return oldItem;
    });
    return outputItems;
};

export const prepareDataRecursive = (inputItems, visited = new WeakSet()) => {
    const outputItems = inputItems.reduce((result, nextItem) => {
        if (nextItem) {
            if (visited.has(nextItem)) {
                return result;
            }
            visited.add(nextItem);

            const newItem = { ...nextItem };
            if (newItem.children) {
                newItem.children = prepareDataRecursive(newItem.children, visited);
            }
            result.push(newItem);
        }
        return result;
    }, []);
    return outputItems;
};

export const setUniqueKeyToItemsRecursive = inputItems => {
    const outputItems = inputItems.reduce((result, nextItem) => {
        if (nextItem) {
            const newItem = { ...nextItem };
            newItem.key = sha256(`${newItem.key}${Math.random()}`).toString();
            if (newItem.children) {
                newItem.children = setUniqueKeyToItemsRecursive(newItem.children);
            }
            result.push(newItem);
        }
        return result;
    }, []);
    return outputItems;
};

/*
 * Функция для проверки наличия дубликатов в массиве
 * @param {Array} array - Массив для проверки
 * @param {Object} item - Объект для проверки
 * @returns {boolean} - true, если дубликат найден, false - иначе
 */
export const hasDuplicate = (array, item) => {
    return array.some(existingItem => {
        // Проверяем по id, если оно есть
        if (item.id && existingItem.id) {
            return existingItem.id === item.id;
        }
        // Иначе проверяем по key
        return existingItem.key === item.key;
    });
};
